import _get from 'lodash/get'

import { DOMAINS_QUERY_PARAM_SHORTCUT } from 'features/domains/consts'
import { useQuery } from '.'
import { useMemo } from 'react'

function useDomainQueryParams(): string[] {
  const query = useQuery()

  return useMemo(
    () => _get(query, DOMAINS_QUERY_PARAM_SHORTCUT, []) as string[] | [],
    [query]
  )
}

export default useDomainQueryParams
